import React, { useCallback, useRef, useState } from 'react';
import config from './config.json';
import { modalAddOrEditFn } from './components/addOrEdit';
import { modalCodeFn } from './components/codeRule';
import { SActionBtn, SBack, SLowcodeList, STableActions } from 'shj-components'
import { receiptRulesPlanMainPageList, receiptRulesPlanMainIsEnabled } from '@/services/fmsConfig'
import { useNavigate } from 'react-router-dom'
import {message} from 'antd'
export default function () {
  const history = useNavigate();
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        let data = await receiptRulesPlanMainPageList(current, pageSize, rest.query);
        const { records, total } = data;
        resolve({ records, total });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise((resolve, reject) => {
      resolve({
        statusOptions: [{
          value: 1,
          label: '启用',
        },{
          value: 0,
          label: '禁用',
        }],
      });
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const handleAction = useCallback((action: 'look' | 'add' | 'edit', obj = {}) => {
    const {
      current: { reload },
    } = listRef;
    const actionFn = action === 'look' ? history('/config/receiptRulesManagement/' + obj?.id) : 'add' ? modalAddOrEditFn : modalCodeFn;
    const result = actionFn({
      fn: (id)=>{
        // 检查 fn 的返回值
        if (id) {
          history('/config/receiptRulesManagement/' + id);
        } else {
          reload();
        }
      },
      ...obj,
    });
    console.log(result)
  }, []);

  const onAdd = useCallback(() => handleAction('add'), [handleAction]);

  const onLook = useCallback((record) => handleAction('look', record), [handleAction]);

  const onEdit = useCallback((record) => handleAction('edit', record), [handleAction]);

  // const onDel =
  //   (record) => {
  //     prodReceiptRulePageDelete(record.id).then((response: any) => {
  //       message.success(response?.message || '删除成功');
  //       reloadFn();
  //     });
  // }

  const handleStatusChange = useCallback((isStart: boolean, selectedRows: any[]) => {
    const list = selectedRows.map(m => m.id);
    receiptRulesPlanMainIsEnabled({ rulesIds: list, isStart })
      .then((response: any) => {
        message.success(response?.message || '操作成功');
        reloadFn();
      });
  }, []);

  const onDisable = useCallback(({ record, rows, selectedRows } = {}) => {
    handleStatusChange(false, selectedRows);
  }, [handleStatusChange]);

  const onEnable = useCallback(({ record, rows, selectedRows } = {}) => {
    handleStatusChange(true, selectedRows);
  }, [handleStatusChange]);

  const onEnableChange = (checked: any, record: any) => {
    if (checked) {
      onEnable({ record });
    } else {
      onDisable({ record });
    }
  };
  const onCopy = useCallback((record) => handleAction('edit', {...record, showCopy: true}), [handleAction]);

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onEnable, onDisable, onEnableChange },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      statusCell(text: any) {
        return text ? '启用' : '禁用';
      },
      isDefaultCell(text: any) {
        return text ? '是' : '否';
      },
      // 渲染操作栏
      renderOperate(text: string, record: object) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              <SActionBtn onClick={() => onLook(record)}>
                明细
              </SActionBtn>
              <SActionBtn onClick={() => onCopy(record)}>
                复制
              </SActionBtn>
              {/* <SActionBtn title="是否删除？" danger confirm
                onClick={() => onDel(record)} okText="是" cancelText="否" >
                删除
              </SActionBtn> */}
            </STableActions>
          </div>
        );
      },
    },
  };

  return <><SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" /></>
}
